const Policies = () => {
  return (
    <div className="text-sm xl:text-base">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum quasi
      velit, animi a exercitationem suscipit tenetur! Eos dolores perferendis
      nesciunt possimus minus molestias modi aliquid ipsam sapiente quod ut
      vitae asperiores, maiores debitis libero? Ullam dolorem mollitia,
      praesentium error quas voluptatem aut corrupti consequuntur, nisi
      aspernatur animi numquam? Tenetur aut reprehenderit assumenda repudiandae
      earum debitis, fugiat culpa, saepe, ullam qui reiciendis ipsa quia
      deleniti esse odit. Delectus ad deleniti dicta id, nemo minus tenetur hic
      odit aliquid porro cumque tempora dolor placeat dolores officia similique
      perferendis aspernatur laudantium! Quod sed numquam quibusdam aut. Ad
      labore provident facere maxime illum cum quod deserunt unde officiis
      eligendi repellendus esse aspernatur, ipsum quasi iste. Rem eveniet
      voluptates dolore tenetur! Illo mollitia rerum molestiae architecto odio
      error vero possimus magni id voluptatibus voluptas quas iste similique,
      quibusdam esse, eligendi velit facilis ex quidem iure dolorem? Pariatur
      sint amet tenetur, blanditiis accusamus eum. Accusamus obcaecati, possimus
      quasi suscipit recusandae earum labore? Iste aliquam deserunt, laboriosam,
      doloremque enim rem mollitia aperiam inventore, eligendi autem maiores
      earum! Velit rerum aut voluptatum nostrum necessitatibus itaque tenetur
      vero dolor impedit dolores doloribus, perferendis earum sunt minima, quae
      cupiditate. Eveniet non ex excepturi? Natus labore doloremque,
      perspiciatis quas doloribus veniam aut inventore ratione in necessitatibus
      voluptates eaque nulla expedita quisquam ipsum amet quibusdam accusantium
      illo architecto, laboriosam voluptas vitae est sunt! Veniam minus ducimus
      officia deleniti cumque quod cum perspiciatis soluta hic atque ab
      similique delectus ipsam, nostrum temporibus excepturi dolorum distinctio
      quam dolor sunt accusamus aliquam vero quaerat. Saepe voluptatem, rerum,
      cumque libero asperiores, ipsum totam eos veritatis autem facilis quod
      mollitia impedit vel non quae molestias excepturi dolores dolore natus
      doloribus sed neque! Cumque, minus cupiditate vel minima dolores molestias
      ad nemo voluptatem alias accusamus recusandae officia! Quibusdam facilis
      harum architecto eaque quis molestias iusto quia rem officiis sed, placeat
      velit error soluta repellendus et amet laborum hic totam quo ut vel ipsum
      ullam nobis. Alias aliquam expedita modi dolorum sint recusandae nam unde
      eos, velit ad repellendus. Quisquam quas, velit at, aliquam odio assumenda
      non dolorum quasi vitae qui modi possimus maxime ex officia voluptatibus
      distinctio necessitatibus debitis quo quae. Adipisci laudantium
      praesentium ipsa aspernatur nesciunt quasi harum, minus fugiat ducimus
      commodi cumque porro laborum illo eligendi voluptates totam, alias illum
      autem dolorem? Accusamus, suscipit dolorum! Deleniti quasi assumenda
      tenetur eius nobis quas quos sint quo illum doloremque sit rem error,
      aliquam beatae dolor odio veniam eos cupiditate magni maxime vero
      inventore fugiat quae. Neque ab sequi quibusdam odit provident ipsa eum
      tempora qui assumenda placeat ducimus, sapiente ut incidunt fugiat
      voluptas dolorum illum enim maxime veritatis id! Fuga doloremque vel
      quibusdam nisi molestiae quisquam laudantium sequi blanditiis magnam,
      expedita voluptates, autem ipsam rem aliquam. Quod enim rerum
      reprehenderit deleniti? Aut deserunt alias error, aperiam doloribus nulla
      ipsa sit, blanditiis exercitationem non numquam fuga, accusantium mollitia
      dolore reiciendis nobis assumenda nesciunt. Sed animi atque et voluptatum
      quaerat labore magnam in ipsam error, aspernatur ea corporis ex unde,
      quibusdam minus accusantium, enim veritatis sit hic vel vero eligendi.
    </div>
  )
}

export default Policies
